import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { handleImageToText, parseOcrTextToJson } from "../lib/utils";

interface Props {
  label: string;
  value: string;
  placeholder?: string;
  setValue: (val: string) => void;
}

const PasteImageOCR: React.FC<Props> = ({
  label,
  value,
  setValue,
  placeholder,
}) => {
  const divRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);

  const handlePaste = async (e: React.ClipboardEvent<HTMLDivElement>) => {
    const items = e.clipboardData.items;
    for (const item of Array.from(items)) {
      if (item.type.startsWith("image/")) {
        const file = item.getAsFile();
        if (file) {
          setLoading(true);
          try {
            const text = await handleImageToText(file);
            const textjson = parseOcrTextToJson(text);
            setValue(JSON.stringify(textjson, null, 2));
            toast.success(`📝 Đã nhận diện ảnh từ ${label}`);
          } catch (err) {
            console.log(err);
            toast.error(`❌ Lỗi khi OCR ảnh từ ${label}`);
          } finally {
            setLoading(false);
          }
        }
      }
    }
  };

  return (
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-600">
        📋 Paste ảnh {label}:
      </label>

      <div
        ref={divRef}
        tabIndex={0}
        onClick={() => divRef.current?.focus()}
        onPaste={handlePaste}
        className={`border rounded px-4 py-10 bg-gray-50 cursor-pointer hover:bg-gray-100 text-sm text-gray-700 outline-dashed focus:outline-blue-400 ${
          loading ? "opacity-70 pointer-events-none" : ""
        }`}
      >
        👉 Click để chọn, rồi Ctrl + V để dán ảnh từ clipboard
        {loading && <span className="ml-2 text-xs">⏳ Đang xử lý...</span>}
      </div>

      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="w-full border rounded px-3 py-2 text-sm font-mono"
        rows={10}
        placeholder={placeholder}
      />
    </div>
  );
};

export default PasteImageOCR;
